import React from 'react'
import CodeInput from 'react-code-input'
import './otp-input.scss'

const OtpInput = ({ fields = 6, onChange }) => {
	return (
		<div className='f-otp-input'>
			<CodeInput onChange={onChange} fields={fields} />
		</div>
	)
}

export default OtpInput
